import { Link } from "react-router-dom";
import { allMovies, categories } from "@/lib/movies";

const entries = categories.filter((item) => item.slug !== "all");

export default function CategoryEntries() {
  return (
    <section className="px-4 md:px-8 lg:px-12 py-14 md:py-20">
      <div className="max-w-shell mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {entries.map((category) => {
            const items = allMovies.filter((movie) => movie.type === category.slug);
            const cover = items[0];
            return (
              <Link
                key={category.slug}
                to={`/category/${category.slug}`}
                className="group relative h-[200px] md:h-[240px] rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-400/70 transition-colors cursor-pointer"
              >
                <img
                  src={cover?.backdrop ?? cover?.poster}
                  alt={`${category.name}电影分类`}
                  title={`${category.name} - 韩国伦理电影在线观看`}
                  className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/60 to-background-50/20"></div>
                <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-end">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="font-label text-[10px] tracking-[0.28em] text-primary-400">
                      {category.en}
                    </span>
                    <span className="h-4 px-1.5 rounded bg-background-50/70 text-foreground-800 text-[10px] flex items-center">
                      {items.length} 部
                    </span>
                  </div>
                  <h3 className="font-heading text-xl md:text-2xl text-foreground-950 font-semibold flex items-center gap-2">
                    {category.name}
                    <i
                      className="ri-arrow-right-up-line text-lg text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity"
                      aria-hidden="true"
                    ></i>
                  </h3>
                  <p className="mt-1.5 text-xs md:text-sm text-foreground-600">{category.tagline}</p>
                </div>
              </Link>
            );
          })}
        </div>

        <Link
          to="/category/all"
          className="mt-4 md:mt-5 flex items-center justify-between gap-4 rounded-lg border border-background-200/70 bg-background-100/60 px-5 md:px-6 py-4 hover:border-primary-400/60 transition-colors cursor-pointer"
        >
          <div className="flex items-center gap-3 min-w-0">
            <span className="w-9 h-9 rounded-md bg-secondary-100 text-secondary-900 flex items-center justify-center shrink-0">
              <i className="ri-stack-line text-base" aria-hidden="true"></i>
            </span>
            <div className="min-w-0">
              <p className="text-sm text-foreground-900 font-medium truncate">
                进入全部片库 · {allMovies.length} 部影片
              </p>
              <p className="text-xs text-foreground-500 mt-0.5 truncate">
                按年份、评分与分类筛选，找到今晚想看的那一部
              </p>
            </div>
          </div>
          <span className="text-sm text-primary-500 flex items-center gap-1 whitespace-nowrap shrink-0">
            浏览片库
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </span>
        </Link>
      </div>
    </section>
  );
}